module.exports = __webpack_public_path__ + "img/8.0943c45e.png";